import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "37",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202020",
      d: "M22.193 0a8.2 8.2 0 0 1-1.877 5.878 6.9 6.9 0 0 1-5.45 2.576 7.8 7.8 0 0 1 1.926-5.66A8.35 8.35 0 0 1 22.193 0M26.001 15.494a8.33 8.33 0 0 0-1.085 4.005 8.05 8.05 0 0 0 4.915 7.408 18.5 18.5 0 0 1-2.556 5.207c-1.506 2.253-3.085 4.454-5.591 4.494-1.192.028-1.997-.315-2.835-.672-.875-.373-1.786-.76-3.212-.76-1.512 0-2.464.4-3.383.786-.793.334-1.561.657-2.644.702-2.387.089-4.21-2.404-5.772-4.636C.72 27.471-1.71 19.185 1.546 13.547a8.95 8.95 0 0 1 7.532-4.594c1.354-.027 2.653.494 3.791.952.871.35 1.649.662 2.285.662.56 0 1.315-.3 2.196-.65 1.387-.55 3.084-1.224 4.813-1.042a8.53 8.53 0 0 1 6.72 3.633 8.33 8.33 0 0 0-2.882 2.986"
    }, null, -1)
  ]))]))
}
export default { render: render }